
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchProductThicknesses } from './fetch-product-thicknesses';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  enabled?: boolean;
  initialData?: P | null;
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-product-thicknesses`;
};

/**
 * `useProductThicknesses` hook.
 */

function useProductThicknesses<P>(options?: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const enabled = options?.enabled !== false;
  const result = useQuery([actionType(variables), variables], () => {
    return fetchProductThicknesses(variables);
  }, {
    enabled,
    initialData: options?.initialData
  });

  return result;
}

/**
 * Export `useProductThicknesses` hook.
 */

export default useProductThicknesses;
